import {
  CUSTOM_COMPONENT_DELETE_CUSTOM_COMPONENT_CONFIG_BEGIN,
  CUSTOM_COMPONENT_DELETE_CUSTOM_COMPONENT_CONFIG_SUCCESS,
  CUSTOM_COMPONENT_DELETE_CUSTOM_COMPONENT_CONFIG_FAILURE,
  CUSTOM_COMPONENT_DELETE_CUSTOM_COMPONENT_CONFIG_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function deleteCustomComponentConfig(args = {}) {
  return (dispatch) => {
    dispatch({
      type: CUSTOM_COMPONENT_DELETE_CUSTOM_COMPONENT_CONFIG_BEGIN,
    });

    const { projectId, version, uuid } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/custom-component/${uuid}`,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: CUSTOM_COMPONENT_DELETE_CUSTOM_COMPONENT_CONFIG_SUCCESS,
              data: res.data,
            });
            toast.success('Request Deleted Successfully');
            resolve(res);
          } else {
            dispatch({
              type: CUSTOM_COMPONENT_DELETE_CUSTOM_COMPONENT_CONFIG_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: CUSTOM_COMPONENT_DELETE_CUSTOM_COMPONENT_CONFIG_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteCustomComponentConfigError() {
  return {
    type: CUSTOM_COMPONENT_DELETE_CUSTOM_COMPONENT_CONFIG_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CUSTOM_COMPONENT_DELETE_CUSTOM_COMPONENT_CONFIG_BEGIN:
      return {
        ...state,
        deleteCustomComponentConfigPending: true,
        deleteCustomComponentConfigError: null,
      };

    case CUSTOM_COMPONENT_DELETE_CUSTOM_COMPONENT_CONFIG_SUCCESS:
      const customComponents = state.customComponents.filter(
        (comp) => comp.uuid !== action.data.uuid,
      );
      return {
        ...state,
        deleteCustomComponentConfigPending: false,
        deleteCustomComponentConfigError: null,
        customComponents,
      };

    case CUSTOM_COMPONENT_DELETE_CUSTOM_COMPONENT_CONFIG_FAILURE:
      return {
        ...state,
        deleteCustomComponentConfigPending: false,
        deleteCustomComponentConfigError: action.data.error,
      };

    case CUSTOM_COMPONENT_DELETE_CUSTOM_COMPONENT_CONFIG_DISMISS_ERROR:
      return {
        ...state,
        deleteCustomComponentConfigError: null,
      };

    default:
      return state;
  }
}
